import { render } from "./CreateOOCAnalysis.vue?vue&type=template&id=bcca1682&ts=true"
import script from "./CreateOOCAnalysis.vue?vue&type=script&lang=ts"
export * from "./CreateOOCAnalysis.vue?vue&type=script&lang=ts"

import "./CreateOOCAnalysis.vue?vue&type=style&index=0&id=bcca1682&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__